import { render, staticRenderFns } from "./CompetitionList.vue?vue&type=template&id=0622df3a&scoped=true&"
import script from "./CompetitionList.vue?vue&type=script&lang=js&"
export * from "./CompetitionList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionList.vue?vue&type=style&index=0&id=0622df3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622df3a",
  null
  
)

export default component.exports